(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takumi-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-takumi-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takumi-header"]) return;
  try {
    
  (() => {
    const headers = document.querySelectorAll('.takumi-header');
    headers.forEach((header) => {
      const toggle = header.querySelector('.takumi-header__toggle');
      const menu = header.querySelector('.takumi-header__mobile');
      if (!toggle || !menu) return;
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        toggle.setAttribute('aria-label', open ? 'Abrir menú' : 'Cerrar menú');
        menu.hidden = open;
      });
    });

    const dropdowns = document.querySelectorAll('.takumi-header__dropdown');
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;
        dropdowns.forEach((other) => {
          if (other !== dropdown) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      dropdowns.forEach((dropdown) => {
        if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      dropdowns.forEach((dropdown) => {
        if (!dropdown.open) return;
        dropdown.removeAttribute('open');
        dropdown.querySelector('summary')?.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takumi-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const products = document.querySelectorAll('[data-takumi-product]');
    products.forEach((product) => {
      const variantsNode = product.querySelector('[data-product-variants]');
      const variantId = product.querySelector('[data-variant-id]');
      const price = product.querySelector('[data-product-price]');
      const addButton = product.querySelector('[data-add-button]');
      const addLabel = product.querySelector('[data-add-label]');
      const fileInput = product.querySelector('[data-file-input]');
      const fileLabel = product.querySelector('[data-file-label]');
      if (!variantsNode || !variantId || !addButton || !addLabel) return;

      const variants = JSON.parse(variantsNode.textContent);
      const availableLabel = addButton.dataset.availableLabel;
      const soldOutLabel = addButton.dataset.soldOutLabel;

      const updateVariant = () => {
        const selected = Array.from(product.querySelectorAll('.takumi-product-option')).map((group) => {
          return group.querySelector('.takumi-product-option__input:checked')?.value;
        });
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        if (!variant) {
          addButton.disabled = true;
          return;
        }
        variantId.value = variant.id;
        if (price) price.textContent = variant.price;
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? availableLabel : soldOutLabel;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      product.querySelectorAll('.takumi-product-option__input').forEach((input) => input.addEventListener('change', updateVariant));

      if (fileInput && fileLabel) {
        fileInput.addEventListener('change', () => {
          if (fileInput.files.length > 0) fileLabel.textContent = fileInput.files[0].name;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
